import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router' // Router,
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { UserAccessGateway } from '../common/gateways/user-access-gateway'
import { AuthenticationResult } from '../common/models/authentication-result'
import { Router } from '@angular/router'
import { PortalGlobals } from '../../app/portalglobals'

@Injectable()
export class CanActivateGaurd {
    constructor(private userAccessGateway: UserAccessGateway, private router: Router, private portalGlobal: PortalGlobals) {
        // , private router: Router
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | undefined> {
        return this.checkAuthorization(state)
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | undefined> {
        return this.checkAuthorization(state)
    }

    private checkAuthorization(state: RouterStateSnapshot) {
        let route = this.getRoute()
        let planyear = 0
        const isMfaOtpValidated = localStorage.getItem( "isMfaValidated")
        const mfaOtpValidatedValue = isMfaOtpValidated ==="true" ? "true " : "false"
        if (this.portalGlobal.selectedPlanYear != undefined && this.portalGlobal.selectedPlanYear != null) {
            planyear = this.portalGlobal.selectedPlanYear
        }
        if (planyear == 0) {
            if (localStorage.getItem('PLANYEAR') != undefined && localStorage.getItem('PLANYEAR') != null) {
                planyear = Number(localStorage.getItem('PLANYEAR'))
            }
        }
        return this.userAccessGateway.checkAuthorizationForRoute(state.url, planyear, mfaOtpValidatedValue).pipe(
            map((authenticationResult: AuthenticationResult) => {
                if (authenticationResult.isAuthenticated === true) {
                    return true
                } else {
                    if (authenticationResult.isInternalRoute) {
                        this.router.navigate([authenticationResult.redirectUrl])
                    } else {
                        window.location.href = authenticationResult.redirectUrl
                    }
                }
            })
        )
        //.catch((error) => {
        //   console.log(error)
        //   location.href = '/Auth/Login.aspx'
        //   return Observable.of(false)
        //})
    }

    private getRoute(): string {
        var route: string
        route = location.href
        console.log('auth: current route' + route)
        return route
    }
}
